import { ABTest } from '@/shared/types/ABTest';

type IsABTestEnabled = ABTest | Partial<ABTest[]> | undefined;

const IS_AB_TEST_ENABLED = '0';

export const isABTestEnabled = (abTest: IsABTestEnabled) => {
  if (!abTest) {
    return false;
  }

  if (Array.isArray(abTest)) {
    return abTest.some((test) => test?.option.id === IS_AB_TEST_ENABLED);
  }

  return abTest?.option.id === IS_AB_TEST_ENABLED;
};
